<template>
  <div>
    <h6>Close Reason Level {{ level }}</h6>
    <div class="mt-3">
      <div v-if="hasReasonItems">
        <template v-for="(item, index) in items">
          <reason-item-card :key="`reason-item-${index}`" :item="item" :level="level" />
        </template>
      </div>
      <div v-else class="text-xs-center grey lighten-3 py-3 mb-6" style="border-radius: 8px">
        - No Reason -
      </div>
    </div>
  </div>
</template>

<script>
import ReasonItemCard from './ReasonItemCard.vue'
export default {
  components: {
    ReasonItemCard
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    level: {
      type: String,
      default: ''
    }
  },
  computed: {
    hasReasonItems() {
      return this.items && this.items.length > 0
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/customize/nt/Reason/ReasonItems.vue